import { Button } from "@/components/ui/button";
import { X, CheckCheck, Archive, Clock, Trash2 } from "lucide-react";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";

interface NotificationBulkActionsBarProps {
  selectedCount: number;
  onClearSelection: () => void;
  onMarkAsRead: () => void;
  onArchive: () => void;
  onDelete: () => void;
  onSnooze: (duration: number) => void;
}

export function NotificationBulkActionsBar({
  selectedCount,
  onClearSelection,
  onMarkAsRead,
  onArchive,
  onDelete,
  onSnooze,
}: NotificationBulkActionsBarProps) {
  if (selectedCount === 0) return null;

  return (
    <div className="fixed bottom-6 left-1/2 transform -translate-x-1/2 z-50 animate-in slide-in-from-bottom-4">
      <div className="bg-primary text-primary-foreground rounded-full shadow-2xl px-6 py-4 flex items-center gap-4">
        <span className="font-medium">
          {selectedCount} notification{selectedCount > 1 ? "s" : ""} selected
        </span>

        <div className="h-6 w-px bg-primary-foreground/20" />

        <div className="flex items-center gap-2">
          <Button
            variant="ghost"
            size="sm"
            onClick={onMarkAsRead}
            className="text-primary-foreground hover:bg-primary-foreground/10"
          >
            <CheckCheck className="h-4 w-4 mr-2" />
            Mark Read
          </Button>

          <DropdownMenu>
            <DropdownMenuTrigger asChild>
              <Button
                variant="ghost"
                size="sm"
                className="text-primary-foreground hover:bg-primary-foreground/10"
              >
                <Clock className="h-4 w-4 mr-2" />
                Snooze
              </Button>
            </DropdownMenuTrigger>
            <DropdownMenuContent>
              <DropdownMenuItem onClick={() => onSnooze(30)}>
                30 minutes
              </DropdownMenuItem>
              <DropdownMenuItem onClick={() => onSnooze(60)}>
                1 hour
              </DropdownMenuItem>
              <DropdownMenuItem onClick={() => onSnooze(240)}>
                4 hours
              </DropdownMenuItem>
              <DropdownMenuItem onClick={() => onSnooze(1440)}>
                Tomorrow
              </DropdownMenuItem>
            </DropdownMenuContent>
          </DropdownMenu>

          <Button
            variant="ghost"
            size="sm"
            onClick={onArchive}
            className="text-primary-foreground hover:bg-primary-foreground/10"
          >
            <Archive className="h-4 w-4 mr-2" />
            Archive
          </Button>

          <Button
            variant="ghost"
            size="sm"
            onClick={onDelete}
            className="text-primary-foreground hover:bg-primary-foreground/10 hover:text-red-400"
          >
            <Trash2 className="h-4 w-4 mr-2" />
            Delete
          </Button>
        </div>

        <div className="h-6 w-px bg-primary-foreground/20" />

        <Button
          variant="ghost"
          size="icon"
          onClick={onClearSelection}
          className="text-primary-foreground hover:bg-primary-foreground/10"
        >
          <X className="h-4 w-4" />
        </Button>
      </div>
    </div>
  );
}
